import { useQuery } from "react-query";
import { get_potential_performance_students } from "../../../faunadb/queries/performance";

export default function usePotentialPerformanceStudents(client, id) {
    return useQuery(["performance", id, "potentital-student-list"], () => get_potential_performance_students(client, id), { refetchOnWindowFocus: false })
}